module.exports = __webpack_public_path__ + "img/training_center.bb123343.png";